import React from 'react'
import { PageHeader, Button } from 'antd'
import './styles.css'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import UserMenu from 'components/UserMenu'

export default function LayoutView({
    pageTitle = 'RoRo',
    onClose, handleBack, closeable, extra = [],
    menuVisible, openMenu, closeMenu, menuEnabled,
    children, backgroundColor, customClassName
}) {


    const showBack = handleBack != null
    const onBack = onClose || handleBack

    const avatar = <Button className='menu-trigger-btn' icon={<div>
        <div style={{ backgroundColor: '#000', height: '4px', margin: '3px 0 6px 0' }}></div>
        <div style={{ backgroundColor: '#000', height: '4px', margin: '6px 0' }}></div>
        <div style={{ backgroundColor: '#000', height: '4px', margin: '6px 0 3pxyarn start 0' }}></div>
    </div>}
        onClick={(e) => {
            e.preventDefault();
            openMenu && openMenu()
        }} />

    const avatarProps = menuEnabled ? { icon: avatar } : undefined

    let backIcon = null
    if (closeable)
        backIcon = <ArrowRightOutlined style={{ color: '#5bba47' }} />
    else if (showBack)
        backIcon = <ArrowLeftOutlined />
    return <React.Fragment>
        <PageHeader
            className={customClassName}
            style={{ backgroundColor: backgroundColor }}
            ghost={false}
            backIcon={backIcon}
            onBack={(e) => {
                e.preventDefault();
                onBack()
            }}
            avatar={avatarProps}
            extra={extra}

        />
        <UserMenu visible={menuVisible} onClose={closeMenu} />
        {children}
    </React.Fragment>
}